import { ContattiUtenti } from 'app/model/contatti';
import { IContatto } from 'app/model/contatto';
import { NgbModal, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import { NewContactComponent } from 'app/rubrica/newContact/newContact';
import { ChangeComponent } from 'app/rubrica/changeCategory/change';
import { ConfirmationComponent } from 'app/home/sidebar/confirmation/confirmation';

@Component({
	selector: 'app-rubrica',
	templateUrl: './rubrica.html',
	styleUrls: ['./rubrica.css']
})
export class RubricaComponent {

	filteredContacts: IContatto[];
	page: IContatto[];

	searchKeys = ['nome', 'cognome', 'titolo']; // TODO: Configurare con pesi
	pending: Promise<any> = Promise.resolve(true);

	constructor(
		private readonly modalService: NgbModal,
		readonly contatti: ContattiUtenti
	) { }

	deleteContact(value: IContatto) {
		const modalRef = this.modalService.open(ConfirmationComponent);
		modalRef.componentInstance.setElementoDaCancellare(value.nome);
		modalRef.result
			.then(() => {
				this.pending = this.contatti.delete(value);
			})
			// Non faccio nulla se l'utente decide di non cancellare
			.catch(() => { });
	}

	updateContact(value: IContatto, update) {
		this.contatti.update(Object.assign({}, value, update));
	}

	addContact() {
		const modalRef = this.modalService.open(NewContactComponent);
		modalRef.result.then(
			(contact: IContatto) => this.contatti.add(contact),
			() => { }
		);
	}

	changeCategory(value: IContatto) {
		const modalRef = this.modalService.open(ChangeComponent);
		modalRef.componentInstance.setCategory(value.categoria);
		modalRef.result.then(
			(cat: string) => this.contatti.update(Object.assign({}, value, { categoria: cat })),
			() => { }
		);
	}

	valid(value: IContatto) {
		return value.indirizzo && value.numciv && value.citta;
	}

	contactTabChanged(contatto: IContatto, $event: NgbTabChangeEvent) {
		contatto['selectedTab'] = $event.nextId;
	}
}



// WEBPACK FOOTER //
// ./src/app/rubrica/rubrica.ts